<template>
    <div class="template-detail">
        <template v-if="showButtons">
            <float-buttons calculator v-show="loadSuccess" calculatorFun @calculator="addCalculator"></float-buttons>
            <div class="float-buttons" v-show="loadSuccess">
                <div class="img" v-for="button in buttons" :key="button.key" @click="floatButtonClick(button)"><img :src="button.imgPath" /></div>
            </div>
        </template>

        <sd-header class="header" showBack @back="$utils.back()" :title="title" v-show="loadSuccess">
            <!-- <div slot="right" class="tips">
                <img src="@/assets/img/tips.png" />
                <span class="text">Tips</span>
            </div> -->
        </sd-header>
        <iframe id="templateiframe" class="iframe" frameborder="0" width="100%" scrolling="auto" :src="iframeSrc" v-if="showThrieD"></iframe>
        <sd-share title="Share 3D Display To" v-if="showShare" @success="shareSuccess" @close="showShare = false" :src="shareLink"></sd-share>
        <div class="save-success" v-if="showSuccess">
            <img src="@/assets/img/success.png" />
            <div class="text">{{$t('text.login_successful')}}</div>
        </div>

        <sd-mask v-if="showInfoMask" @click.native="showInfoMask = false" class="page-mask">
            <div class="bottom-mask"></div>
            <div class="template-info-content noscrollbar" @click.stop ref="templateInfo" :style="templateInfoStyle">
                <div class="header">
                    <div class="text">{{$t('text.template_using_product')}}</div>
                    <svg-icon icon-class="close" @click.native="showInfoMask = false"></svg-icon>
                </div>
                <div class="content noscrollbar">
                    <div class="types" :class="`type${typeIndex+1}`" v-for="(typeList, typeIndex) in configList" :key="typeIndex" v-show="typeList.length">
                        <div class="type-name" v-if="typeList.length">{{typeList[0].type == '1'? $t('text.floor') : $t('text.wall')}}</div>
                        <div class="item" v-for="(item, index) in typeList" :key="index">
                            <div class="img">
                                <img :src="$utils.setSourcePath(item.preview)" />
                            </div>
                            <div class="info">
                                <div class="name">{{item.productName}}</div>
                                <div class="info-footer">{{$utils.firstToUpper(item.brandName)}}&nbsp;&nbsp;|&nbsp;&nbsp;{{item.typeName}}</div>
                            </div>
                            <div class="button" @click="showDetail(item)">{{$t('text.details')}}</div>
                        </div>
                        <div class="line"></div>
                    </div>
                </div>
            </div>
        </sd-mask>
        <sd-message-box :info="messageBoxInfo" @confirm="share(true)" showCancel @cancel="share(false)" class="page-message-box"></sd-message-box>
    </div>
</template>

<script>
export default {
    data() {
        return {
            image:'',
            loadSuccess: false,
            showThrieD: false,
            showInfoMask: false,
            id: null,
            uuid: null,
            planid: null,
            title: "",

            buttons: [{
                key: "info",
                imgPath: require("@/assets/img/info.png")
            },{
                key: "case",
                imgPath: require("@/assets/img/case.png")
            },{
                key: "save",
                imgPath: require("@/assets/img/save.png")
            },{
                key: "share",
                imgPath: require("@/assets/img/share3.png")
            }],
            showShare: false,
            showSuccess: false,
            configList: [], // 样板间配置信息
            sideList: [], // 样板间返回的格式化信息
            sideListOriginal: [], // 样板间返回的原本信息
            fullscreen: false,

            templateInfoH: 0,
            showButtons: true, // 显示按钮
            shareLink: "",
            messageBoxInfo: {
                show: false,
                text: "Save the collocation and share it?"
            },
        }
    },

    computed: {
        userinfo() {
            return this.$store.state.user.userinfo;
        },

        iframeSrc() {
            // console.log("https://display.kedaceramics.com" + "/template/?template_uuid=" + this.uuid + "&&user_type=1&&user_id=" + (this.$store.getters.isLogin? this.userinfo.client_user_id : "0") + (this.planid? '&&template_plan_id'+this.planid : ''),"url")
            return "https://display.kedaceramics.com" + "/template/?template_uuid=" + this.uuid + "&&user_type=1&&user_id=" + (this.$store.getters.isLogin? this.userinfo.client_user_id : "0") + (this.planid? '&&template_plan_id='+this.planid : '');
        },
        
        templateInfoStyle() {
            if(!this.templateInfoH) return '';
            return `height: ${this.templateInfoH+5}px;`
        }
    },

    watch: {
        $route: {
            handler(){
                let route = this.$route;
                    // console.log(route,"rout")

                if(route.name == 'templatedetail') {
                    const { id, uuid, name, template_plan_id } = this.$route.query;
                    // console.log(this.$route.query,id, uuid, name, template_plan_id)
                    if(id != this.id || uuid != this.uuid) this.loadSuccess = false;
                    this.id = id;
                    this.uuid = uuid;
                    this.title = name;
                    this.planid = template_plan_id
                    this.showThrieD = true;
                    if(this.planid){
                    // this.getData();
                    }
                    window.addEventListener('message', this.handleMessage)
                }else {
                    window.removeEventListener('message', this.handleMessag, true)
                }
            },
		    immediate:true
        }
    },

    methods: {
          base64toFile(data, fileName) {
          const dataArr = data.split(",");
          const byteString = atob(dataArr[1]);
          const options = {
            type: "image/jpeg",
            endings: "native"
          };
          const u8Arr = new Uint8Array(byteString.length);
          for (let i = 0; i < byteString.length; i++) {
            u8Arr[i] = byteString.charCodeAt(i);
          }
          return new File([u8Arr], fileName + ".jpg", options);//返回文件流
    },
        iframeLoad() {
            // 在iframe渲染之前将高度设置0
            const iframe = document.querySelector('#templateiframe')
            // 监听iframe渲染dom的节点
            iframe.onload = function () {
                // 在内嵌页面渲染完成后，通过定时器再设置页面高度，注意：定时器必须加，毫秒单位不能为0
            }
        },

        getData() {
            // this.$apis.template.getTemplateInfo({
            //     template_uuid: this.uuid
            // }).then(res => {

            // })
            this.$apis.template.getTemplatePlanInfo({
                template_plan_id: this.planid
            }).then(res => {
                console.log(res,"配置")
            })
        },

        floatButtonClick(item) {
            //    console.log(item)
            var data = item;
            //  let params = data.params || {};
            let image = (data.imgPath || {})
            try {
                image =image
               
            } catch (error) {
                image = {}
            }
            switch(item.key) {
                case "info": this.showInfo(); break;
                // case "share": this.showShare = true; break;
                case "share": this.share(false); break;
                case "save": this.save(); break;
                case "case": this.toPage('/template-record'); break;
            }
        },

        async share(getPlanId) {
        
            this.messageBoxInfo.show = false;
            if(getPlanId === true) {
                try {
                    let res = await this.save(true);
                    let planId = res[0].data.plan_id;
                    let params = this.getUrlParams(window.location.href);
                    params.template_plan_id = planId;
                    let paramsArr = [];
                    for(var key in params) {
                        paramsArr.push(`${key}=${params[key]}`);
                    }
                    this.shareLink = `${window.location.origin}/#/template-detail?${paramsArr.join('&')}`;
                    this.showShare = true;
                } catch (error) {
                }
            } else if (getPlanId === false) {
                // this.shareLink = window.location.href;
                // this.showShare = true;
            } else {
                this.messageBoxInfo.show = true;
            }
            
            
        },

        fav() {
            this.$apis.template.templateFav({
                template_id: this.id || this.uuid
            }).then(res => {
                if(res.data.is_fav == '1') this.$utils.message(this, "favorite successfully");
            })
        },

        // 添加搭配记录
        async save(byShare = false) {
            this.$store.commit("changeLoading", this.$t('text.loading'));

    await  this.sendMessage('getTemplateImage');
  const sleep = (delay) => new Promise((resolve) => setTimeout(resolve, delay))
            if(!this.$store.getters.isLogin) {
                this.$utils.toLogin();
                return;
            }
            if(this.showSuccess) return;
            if(this.sideList.length) {
   await sleep(1000)

        console.log(this.image,'jietu')
        let str =this.base64toFile(this.image,'jietu')
        let formData = new FormData();

        formData.append("file", str);
        //发送给后端
          formData.append("img_path","h5_img");
     let imagess = await this.$apis.common.uploadImg(formData)
     
     const images= imagess.data.path

            console.log(images,"image",imagess)
                let side_list = this.sideListOriginal.map(item => {
                    let obj = {
                        side_uuid: item.side_uuid,
                        side_name: item.side_name,
                        pave_mode_uuid: item.pave_mode_uuid,
                        pave_mode_name: item.pave_mode_name,
                        product_id_str: item.product_id_str,
                    }
                    return obj;
                });
                //     
                let apis = [this.$apis.template.saveTemplatePlan({ template_uuid: this.uuid, side_list: JSON.stringify(side_list),screenshot:images  })];
                if(this.$route.query.is_fav != 1) apis.push(this.$apis.template.templateFav({ template_id: this.id }))
                        this.$store.commit("changeLoading", false);
                try {
                    let res = await Promise.all(apis)
                    if(byShare) {
                        return res
                    } else {
                        this.showSuccess = true;
                        setTimeout(() => {
                            this.showSuccess = false
                        }, 3000);
                    }
                } catch (error) {
                    return new Promise.reject()
                }
            }else {
                this.sendMessage('getTemplateInfo');
            }
        },
        sendMessage (cmd, params) {
            const iframe = document.getElementById('templateiframe').contentWindow;
            iframe.postMessage({
                cmd, params
                // : {
                //     info: '向iframe中的样板间请求获取样板间资料'
                // }
            }, '*');

        },

        handleMessage(event) {
            var data = event.data;
            let params = data.params || {};
            let info = (data.params || {}).info;
             let image = (data.params || {}).image;
            try {
                info = JSON.parse(info);
            } catch (error) {
                info = {}
            }
            //  try {
            //     this.image = image;
            // } catch (error) {
            //    this.image = image = {}
            // }
            console.log(data.cmd) 

            switch (data.cmd) {
                case 'loaded':
                    this.loadSuccess = true;
                    this.sendMessage('getTemplateInfo');
                    break;
                case 'returnTemplateInfo':
                    this.getInfo(info);
                    break;
                case 'collectFolder':
                    // this.fav();
                    break;
                case 'opModeChanged':
                    this.loadSuccess = params.opMode == 'fullscreen'? false : true;
                    break;
                case 'productChanged':
                    // this.sendMessage('getTemplateInfo');
                    break;
                case 'loginprompt':
                    this.$utils.toLogin();
                    break;
                case 'panelDisplayed': 
                    this.showButtons = !params.display;
                    break;
                case 'returnTemplateImage': 
                    this.image=params.image;

                    break;
                // case 'getTemplateInfo':
                // window.parent.postMessage({
                //         cmd: 'returnTemplateInfo',
                //         params: {
                //             info: "{\"template_uuid\":\"db34ec50-b9a4-4780-b15f-3070e98511d9\",\"side_list\":[{\"side_uuid\":\"3e2e0853-cda3-46d6-9043-6820fe99bb49\",\"type\":\"1\",\"side_name\":\"floor_1\",\"pave_mode_uuid\":\"c595b57f-7ded-46e4-a521-22a9f8664d2d\",\"pave_mode_name\":\"Continuous tile\",\"product_id_str\":\"69730964384911360,69733869011734528\"},{\"side_uuid\":\"e4e7a611-f3ed-486a-92d0-62eef9d9ec1d\",\"type\":\"2\",\"side_name\":\"wall_1\",\"pave_mode_uuid\":\"75d357ce-f2f2-4682-aa46-91cc3f230ef7\",\"pave_mode_name\":\"Misaligned tile 01\",\"product_id_str\":\"69735646834593792,69733869011734528,69738413703696384\"}]}"
                //         }
                //     }, '*')
                // break
            }
        },

        getInfo(data) {
            this.$store.commit("changeLoading", this.$t('text.loading'));
            let ids = [];
            let side_list = [];
            this.sideListOriginal = (data.side_list || []);
            (data.side_list || []).forEach(item => {
                let product_ids = item.product_id_str? item.product_id_str.split(",") : [];
                product_ids.forEach(id => {
                    let obj = {
                        ...item,
                        product_id_str: id
                    }
                    side_list.push(obj);
                })
            })
            side_list = side_list.filter(item => {
                if(ids.includes(item.product_id_str)) {
                    return false
                }else {
                    ids.push(item.product_id_str)
                    return true;
                }
            });
            let list = [];
            let length = 0;
            side_list.forEach(side => {
                length++;
                this.$apis.product.getProductDetail({product_id: side.product_id_str}).then(res => {
                    length--;
                    let obj = res.data || {};
                    // 如果是空对象，提示暂无数据
                    if (Object.keys(obj).length === 0) {
                        this.$utils.message(this, this.$t("text.product_not_exist"));
                        return;
                    }
                    list.push({...side, ...obj});
                    if(length == 0) {
                        this.$store.commit("changeLoading", false);
                        this.sideList = list;
                    }
                }).catch(err => {
                    length--;
                    if(length == 0) {
                        this.$store.commit("changeLoading", false);
                        this.$utils.message(this, "获取详情失败")
                    }
                })
            })
        },

        showInfo() {
            let configList = [[],[]];
            this.sideList.forEach(item => {
                configList[Number(item.type)-1].push(item)
            });
            this.configList = configList;
            this.showInfoMask = true;
            this.$nextTick(() => {
                let templateInfo = this.$refs.templateInfo;
                let h = templateInfo.offsetHeight;
                this.templateInfoH = h;
            })
        },

        showDetail(item) {
            this.$router.push({
                path: '/product-detail',
                query: {
                    id: item.product_id_str
                }
            })
        },

        async addCalculator() {
            try {
                this.$store.commit("changeLoading", true);
                // 添加搭配记录
                let side_list = this.sideListOriginal.map(item => {
                    let obj = {
                        side_uuid: item.side_uuid,
                        side_name: item.side_name,
                        pave_mode_uuid: item.pave_mode_uuid,
                        pave_mode_name: item.pave_mode_name,
                        product_id_str: item.product_id_str,
                    }
                    return obj;
                });
                const PlanRes = await this.$apis.template.saveTemplatePlan({ template_uuid: this.uuid, side_list: JSON.stringify(side_list) });
                let planId = PlanRes.data.plan_id;
                await this.$apis.calculator.addCalculatorSideByTemplatePlan({ template_plan_id: planId });
                await this.$apis.template.delTemplatePlan({ plan_id: planId });
                this.toPage('/calculator');
            } catch (error) { } finally {
                this.$store.commit("changeLoading", false);
            }
        },

        toPage(path, query) {
            this.$router.push({
                path, query
            })
        },

        getUrlParams(url) {
            // 通过 ? 分割获取后面的参数字符串
            let urlStr = url.split('?')[1]
            // 创建空对象存储参数
            let obj = {};
            // 再通过 & 将每一个参数单独分割出来
            let paramsArr = urlStr.split('&')
            for(let i = 0,len = paramsArr.length;i < len;i++){
                // 再通过 = 将每一个参数分割为 key:value 的形式
                let arr = paramsArr[i].split('=')
                obj[arr[0]] = arr[1];
            }
            return obj
        },

        // 分享成功回调
        shareSuccess() {
            this.showShare = false;
            this.$apis.share.shareTemplate({
                template_id: this.id
            })
        }
    },

    beforeDestroy() {
        window.removeEventListener('message', this.handleMessage, true);
    }
}
</script>

<style lang="scss" scoped>
.template-detail {
    height: 100%;
    overflow: hidden;
    background-color: #F4F5F8;

    .iframe {
        width: 100%;
        height: 100%;
        border: none;
    }

    .header {
        position: absolute;
        top: 4px;
        width: 100%;
        font-weight: 500;

        .tips {
            margin-right: 16px;

            img {
                width: 16px;
                height: 16px;
            }

            .text {
                position: relative;
                font-size: 12px;
                color: white;
                top: -3px;
            }
        }

        /deep/ {
            .back {
                color: white;
            }

            .title .text {
                color: white;
                max-width: 100%;
                margin-left: 48px;
                text-align: left;
                font-weight: normal;
            }
        }
    }

    .block-page-buttons {
        bottom: 140px;
    }

    .float-buttons {
        position: absolute;
        right: 10px;
        bottom: 216px;

        .img {
            width: 40px;
            height: 40px;
            margin-top: 12px;
        }
    }

    .block-page-buttons {
        right: 6px;
        bottom: 145px;
    }

    .save-success {
        width: 172px;
        height: 112px;
        border-radius: 8px;
        background-color: rgba(0, 0, 0, 0.8000);
        position: fixed;
        left: 102px;
        top: calc(50% - 56px);
        color: white;
        font-size: 14px;

        img {
            width: 40px;
            height: 40px;
            padding-top: 23px;
            margin-bottom: 8px;
        }
    }

    .template-info-content {
        text-align: left;
        bottom: 0;
        width: 100%;
        position: absolute;
        color: white;
        max-height: 430px;
        // overflow: hidden;
        padding: 20px;
        padding-bottom: 0;
        box-sizing: border-box;
        background-color: rgba(26, 26, 26, 0.8000);

        .header {
            font-size: 15px;
            line-height: 18px;
            font-weight: bold;
            position: static;
            padding-bottom: 16px;

            .close {
                top: 12px;
                right: 12px;
                color: white;
                position: absolute;
            }
        }

        .content {
            height: calc(100% - 34px);
            overflow: auto;
            
            .types {
                margin-top: 16px;

                &:first-child {
                    margin-top: 0;
                }

                .type-name {
                    font-size: 14px;
                    line-height: 20px;
                    font-weight: bold;
                }

                .item {
                    display: flex;
                    height: 40px;
                    margin-top: 12px;

                    .img {
                        width: 40px;
                        height: 40px;
                        background-color: gray;
                    }

                    .info {
                        flex: 1;
                        margin-left: 8px;

                        .name {
                            font-size: 12px;
                            line-height: 14px;
                            margin: 6px 0 2px;
                        }

                        .info-footer {
                            font-size: 20px;
                            transform: scale(0.5);
                            transform-origin: 0 0;
                            margin-top: 4px;
                        }
                    }

                    .button {
                        font-size: 14px;
                        width: 60px;
                        height: 28px;
                        line-height: 28px;
                        background-color: #E22F25;
                        border-radius: 4px;
                        text-align: center;
                    }
                }

                .line {
                    width: 100%;
                    height: 1px;
                    margin-top: 20px;
                    background-color: rgba(255, 255, 255, 0.2);
                }

                &:last-child .line {
                    display: none;
                }
            }
        }
    }

    .page-mask {
        background: rgba(0, 0, 0, 0.6);

        .bottom-mask {
            bottom: 0;
            position: absolute;
            width: 100%;
            height: 215px;
            background: linear-gradient(180deg, rgba(26,26,26,0) 0%, #1A1A1A 100%);
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/template.vue